export default __webpack_public_path__ + "static/media/ac_dd2.e6519043.bmp";